<template>
	<div class="mysubscribe">
		<nav-bar navBarTitle="我的订阅"></nav-bar>
		<div class="subscribe-title">
			<p class="sub-title-l">共有新数据<span>·{{quantity}}条</span></p>
			<p class="sub-title-r">已添加地区<span>{{cardList.length}}</span>/6</p>
		</div>
		<div class="subscribe-card" @click="goNewPage(list)" v-for="(list,index) in cardList" :key="index">
			<div class="subscribe-card-t">
				<div class="sub-c-t-l">{{list.region && list.region.replace(/省|市|区/g, function(i){return i+" "})}}</div>
				<div class="sub-c-t-r" @click.stop="moreHandle(list)">
					<img src="@/assets/img/member/more.png" alt="">
				</div>
			</div>
			<div class="sub-card-tag">
				<p class="card-tag" v-for=" (item,index) in list.keyword" :key="index">{{item}}</p>

			</div>
			<div class="subscribe-card-line"></div>
			<div v-if="list.quantity" class="sub-card-news">
				<p >新数据<span>{{list.quantity}}条</span></p>
				<img src="@/assets/img/member/card-news-icon.png" alt="">
			</div>
			<div v-else class="sub-card-news">
				<p >暂无新数据</p>
				<img src="@/assets/img/member/card-news-icon.png" alt="">
			</div>
		</div>
		<div v-if="cardList.length<6" class="subscribe-card-add" @click="addHandle">
			<img src="@/assets/img/member/sub-card-add-icon.png" alt="">
			<p>添加订阅</p>
		</div>
		<!-- 编辑绑定的区域卡片-->
		<van-popup v-model="isEditMore" position="bottom" class="con-pop-wrap">
			<div class="pop-up">
				<p @click="editHandle">编辑</p>
				<div class="pop-line"></div>
				<div class="con-pop-confirm" @click="removeHandle">删除</div>
			</div>
			<div class="pop-bottom">
				<div class="con-pop-cancel" @click="isEditMore=false">取消</div>
			</div>
		</van-popup>
		<!-- 删除订阅信息确认弹框-->
		<van-popup v-model="confirmPopUp" position="bottom" class="con-pop-wrap">
			<div class="pop-up pop-up-re">
				<p>确认删除此订阅信息吗？</p>
				<div class="pop-line"></div>
				<div class="con-pop-re-confirm" @click="confirmHandle">确定</div>
			</div>
			<div class="pop-bottom">
				<div class="con-pop-cancel" @click="confirmPopUp=false">取消</div>
			</div>
		</van-popup>
		<div class="subscribe-space"></div>
	</div>
</template>
<script>
	import {mySubscribe,deleteMySubscribe,deleteNews} from '../../api/api_member';
	import { cardShareInfo } from '../../api';
	export default {
		data(){
			return {
				isEditMore:false,
				confirmPopUp:false,
				cardList:[],
				cardInfo:{},
				quantity:0,
			}
		},
		created(){
			this.loadata()
		},
		mounted(){
			this.defaultShare()
		},
		methods:{
			// 默认分享
			async defaultShare(){
				let params = {
					type: 9, // 普通分享到产品首页
					title: '政策补贴宝',
					desc: '每个企业都有获得补贴的机会，我们让可能变为现实',
				}
				let res = await cardShareInfo(params)
				if(res && res.ok){
					let data = res.data
					this.WechatShare({
						title: data.title,
						desc: data.desc,
						imgUrl: data.imgUrl,
						link: data.linkUrl
					},window.initUrl ? window.initUrl: '')
				}
			},
			goNewPage(item){
				let params={
					id:item.id,
				}
				deleteNews(params).then(res=>{
					if(res.ok===true){
						this.$router.push({
							name:'subscribelist',
							query:{
								id:item.id,
								city:item.region,
								provinceId:item.provinceId,
								cityId:item.cityId,
								regionId:item.regionId
							}
						})
					}else{
						this.$toast(res.msg)
					}
				})
			},
			loadata(){
				mySubscribe().then((res)=>{
					if(res.ok===true){
						this.cardList=res.data
						this.cardList.forEach((res=>{
							this.quantity+=res.quantity
						}))
					}
				})
			},
			moreHandle(info){
				this.cardInfo=info
				this.isEditMore=true
			},
			editHandle(){
				this.$router.push({
					name:'mysubscribeadd',
					query:{
						id:this.cardInfo.id,
						keywords:JSON.stringify(this.cardInfo.keyword),
						provinceId:this.cardInfo.provinceId,
						regionId:this.cardInfo.regionId,
						cityId:this.cardInfo.cityId,
						region:this.cardInfo.region
					}
				})
			},
			removeHandle(){
				this.confirmPopUp=true
			},
			confirmHandle(){
				let keywords=this.cardInfo.keyword && this.cardInfo.keyword.join(',')
				let params={
					id:this.cardInfo.id,
					keyword:keywords,
					provinceId:this.cardInfo.provinceId,
					regionId:this.cardInfo.regionId,
					cityId:this.cardInfo.cityId,
				}
				deleteMySubscribe(params).then((res)=>{
					if(res.ok===true){
						this.$toast('删除成功')
						this.confirmPopUp=false
						this.isEditMore=false
						this.loadata()
					}

				})
			},
			addHandle(){
				let areaData=this.cardList
				this.$router.push({
					name:'mysubscribeadd',
					query:{
						areaData,
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.mysubscribe{
		background: #F5F5F5;
		min-height: 100%;
		.subscribe-space{
			height: 50px;
		}
		.con-pop-wrap{
			width:96%;
			text-align: center;
			background: transparent;
			margin: 0 7px;
			.pop-up{
				width: 100%;
				height: 113px;
				background: #FFFFFF;
				border-radius: 12px;
				margin-bottom: 7px;
				font-size: 18px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #666666;
				line-height: 18px;
				text-align: center;
				padding-top: 16px;
				p{
					margin:0 0 18px;
				}
				.pop-line{
					width: 100%;
					height: 1px;
					background: #CCCCCC;
				}
				.con-pop-confirm{
					line-height: 18px;
					margin:16px 0 18px;
				}
				.con-pop-re-confirm{
					font-size: 18px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #FE0000;
					margin:16px 0 17px;
				}

			}
			.pop-up-re{
				padding: 0;
				p{
					font-size: 12px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #888888;
					line-height: 12px;
					padding:26px 0 23px;
					margin:0
				}

			}
			.pop-bottom{
				width: 100%;
				height: 52px;
				background: #FFFFFF;
				border-radius: 12px;
				font-size: 18px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #007AFF;
				line-height: 52px;
				margin-bottom: 36px;
			}
		}
		.subscribe-card-add{
			width: 343px;
			height: 48px;
			background: #FFFFFF;
			border-radius: 5px;
			display: flex;
			justify-content: center;
			align-items: center;
			line-height: 48px;
			margin:16px 16px 0;
			font-size: 16px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #398DFF;
			line-height: 16px;
			img{
				width:15px;
				height: 15px;
				margin-right: 6px;
				display: inline-block;
			}
			p{
				display: inline-block;
			}
		}
		.subscribe-title{
			width: 100%;
			height: 48px;
			background: #FFFFFF;
			display: flex;
			justify-content: space-between;
			line-height: 48px;
			padding: 0 16px;
		}
		.sub-title-l{
			font-size: 15px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #333333;
			span{
				font-size: 15px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #398DFF;
				line-height: 21px
			}
		}
		.sub-title-r{
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #666666;
			span{
				color:#398DFF;
				display: inline-block;
				margin-left: 5px;
			}
		}
		.subscribe-card{
			box-sizing: border-box;
			background: #FFFFFF;
			border-radius: 4px;
			margin:16px 16px 0;
			padding: 16px;
			.subscribe-card-t{
				display: flex;
				justify-content: space-between;
				.sub-c-t-r img{
					width:16px;
					height: 16px;
				}
			}
			.sub-card-tag{
				margin-top:14px;
				display: flex;
				flex-wrap: wrap;
				.card-tag{
					width: 68px;
					height: 26px;
					background: rgba(57, 141, 255, 0.05);
					border-radius: 3px;
					font-size: 13px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #398DFF;
					line-height: 26px;
					text-align: center;
					margin: 0 8px 8px 0;
				}
			}
			.subscribe-card-line{
				width: 311px;
				height: 1px;
				background: #F1F1F1;
				margin-top:16px;
			}
			.sub-card-news{
				display: flex;
				justify-content: space-between;
				align-items: baseline;
				p{
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #999999;
					line-height: 14px;
					margin:16px 0 0;
					span{
						display: inline-block;
						margin-left: 6px;
						width: 30px;
						background: #FA5151;
						border-radius: 8px;
						border: 1px solid #FFFFFF;
						font-size: 12px;
						font-family: PingFangSC-Medium, PingFang SC;
						font-weight: 500;
						color: #FFFFFF;
						line-height: 16px;
						text-align: center;
					}
				}
				img{
					width:7px;
					height: 13px;
				}
			}
		}
	}
</style>
